/**
 * Customer Engagement Service
 * Handles API calls for customer engagement analytics
 */

import { GetUniqueCustomersResponse } from '../types/customer';
import { getAuthToken } from '../utils/tokenManager';
import { API_BASE_URL } from '../config/api';

/**
 * Get unique customers with engagement data
 * @param limit - Number of records per page
 * @param offset - Offset for pagination
 * @param searchQuery - Optional search query
 * @returns Unique customers data
 */
export const getUniqueCustomers = async (
  limit: number = 50,
  offset: number = 0,
  searchQuery?: string
): Promise<GetUniqueCustomersResponse> => {
  const token = getAuthToken();
  
  if (!token) {
    throw new Error('Authentication token not found. Please log in again.');
  }

  // Build query params
  let queryParams = `limit=${limit}&offset=${offset}`;
  if (searchQuery) {
    queryParams += `&search=${encodeURIComponent(searchQuery)}`;
  }

  console.log('Fetching unique customers...', { limit, offset, searchQuery });

  const response = await fetch(
    `${API_BASE_URL.PROFILE}/contacts/unique-customers?${queryParams}`,
    {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || `Failed to fetch unique customers with status ${response.status}`
    );
  }

  const result: GetUniqueCustomersResponse = await response.json();
  
  console.log('Unique customers loaded:', result);
  return result;
};

